<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>空氣排放管理</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <p>火力發電廠最容易令外界聯想的是燃煤是否會造成空氣污染，因此從一開始，和平電力即致力於要讓空氣污染物排放濃度優於法規標準。</p>
        <p>首先和平電廠鍋爐產生的煙氣，經由脫硝設備（SCR）去除氮氧化物（NOx），靜電集塵器（ESP）去除粒狀污染物（PM），濕式石灰石 / 石膏脫硫設備（FGD）去除硫氧化物（SOx），同時設置 250 公尺高的煙囪，增加排放擴散能力。</p>
      </div>
    </section>
    <section class="sect2">
      <div class="ctx">
        <div class="contOver">
          <div class="diagram">
            <img class="step" src="../../assets/environmentAir/pic2_01.png" />
            <img class="step step2" src="../../assets/environmentAir/pic2_02.png" />
            <img class="step step3" src="../../assets/environmentAir/pic2_03.png" />
            <img class="step step4" src="../../assets/environmentAir/pic2_04.png" />
            <img class="step step5" src="../../assets/environmentAir/pic2_05.png" />
          </div>
        </div>
      </div>
    </section>
    <section class="sect3">
      <div class="ctx">
        <p>為追求更好的空氣品質，和平電廠持續優化，2021 年到 2023 年陸續投入近 33 億台幣進行 AQCS（空氣品質控制系統）的改造工程。</p>
        <p>環境部針對空氣排放氮氧化物（NOx）規定為 70ppm，在完成改造工程後，和平電廠排放數值僅 31ppm，硫氧化物（SOx）和粒狀污染物（PM）更是低於環境部規定標準的一半不到，灼見改善後的成效。</p>
        <div class="contOver">
          <table>
            <tr>
              <th rowspan="2" class="item">項目</th>
              <th colspan="6" class="tableTit">AQCS 空氣品質控制系統 (數值扣除停機天數)</th>
            </tr>
            <tr>
              <th>環保署標準<br>2015 年 12 月</th>
              <th>2021 年</th>
              <th>2022 年</th>
              <th>2023 年</th>
              <th>2024 年</th>
              <th>2025 年</th>
            </tr>
            <tr>
              <td>NOx 氮氧化物 (ppm)</td>
              <td>70</td>
              <td>35</td>
              <td>32.6</td>
              <td>31.7</td>
              <td>30.5</td>
              <td>34</td>
            </tr>
            <tr>
              <td>SOx 硫氧化物 (ppm)</td>
              <td>60</td>
              <td>33</td>
              <td>22.9</td>
              <td>19.3</td>
              <td>22.1</td>
              <td>22.3</td>
            </tr>
            <tr>
              <td>PM 粒狀污染物 (mg/Nm<sup>3</sup>)</td>
              <td>20</td>
              <td>8.5</td>
              <td>4.5</td>
              <td>4.3</td>
              <td>3.8</td>
              <td>2.5</td>
            </tr>
          </table>
        </div>
        <div class="imgContainer3-1"></div>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ImgContainerAutoResize } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

export default defineComponent({
  name: 'EnvironmentAir',
  components: {
    Header,
    Footer
  },
  data() {
    return {
    }
  },
  methods:{
  },
  mounted() {
    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-1") as HTMLElement, 0.7);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: url("@/assets/environmentAir/kv.webp");
  background-position: center top;
  background-size: cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 .sectTit {
  margin: 0 0 10px;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect1 p {
  line-height: 2em;
}

.sect2 {
  background: #fff;
}

.sect2 .diagram {
  width: 1200px;
  padding: 30px 0;
  background: url(../../assets/environmentAir/pic2_00.png) 45% center no-repeat;
  background-size: 90%;
}

.sect2 .diagram .step {
  height: 300px;
  margin: 0 25px 0 0;  
}

.sect2 .diagram .step2,
.sect2 .diagram .step3,
.sect2 .diagram .step4 {
  transform: translateY(-25px);
}

.sect2 .diagram .step5 {
  height: 240px;
  margin: 0 0 80px 50px;
}

.sect3 {
  background: url(../../assets/environmentAir/sectBack3.png), #f4f3f3;
  background-repeat: no-repeat, no-repeat;
  background-position: center, center;
  background-size: cover, cover;
}

.sect3 table {
  width: 1200px;
  margin: 20px 0;
  box-sizing: border-box;
  border-collapse: collapse;
  border: solid 5px #fff;
  text-align: center;
  font-weight: bold;
  font-size: 20px;
}

.sect3 table .tableTit {
  padding: 15px 10px;
  box-sizing: border-box;
  color: #fff;
  background: #63BFAA;
}

.sect3 table .item {
  color: #202020;
  background: #E5E2E1;
}

.sect3 table th {
  padding: 15px 10px;
  box-sizing: border-box;
  color: #fff;
  background: #9E9F9F;
}

.sect3 table tr:nth-child(odd) {
  background: #FAEAE2;
}

.sect3 table tr:nth-child(even) {
  background: #fff;
}

.sect3 table tr td {
  padding: 15px 10px;
  box-sizing: border-box;
  border-top: solid 1px #808080;
}

.sect3 .imgContainer3-1 {
  margin: 40px 0 0;
  border-radius: 30px;
  overflow: hidden;
  background: url(../../assets/environmentAir/pic3_01.jpg) center no-repeat;
  background-size: cover;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }
}
</style>
